(function () {
  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* 加购反馈对标 heybike：加入后当场弹出当店购物车 UI（Concept 抽屉 / Dawn 系弹窗），跨主题探测降级 */
  function cartFeedbackTarget() {
    var el = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (el && typeof el.renderContents === 'function' && typeof el.getSectionsToRender === 'function') return el;
    return null;
  }

  function addToCart(id, btn) {
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    var url = (window.Shopify && Shopify.routes && Shopify.routes.root)
      ? Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js';

    var dawnEl = cartFeedbackTarget();
    var payload = { id: id, quantity: 1 };
    if (dawnEl) {
      try {
        payload.sections = dawnEl.getSectionsToRender().map(function (s) { return s.id; });
        payload.sections_url = window.location.pathname;
      } catch (e) { dawnEl = null; }
    }

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) throw new Error('add failed');
      return res.json();
    }).then(function (data) {
      btn.textContent = 'Added';
      var opened = false;
      if (!dawnEl) dawnEl = cartFeedbackTarget(); /* 自定义元素可能在点击后才完成升级，响应期二次探测 */
      if (dawnEl) {
        try {
          /* 装货 + 摘 is-empty；可重入幂等——只在缺货时动手 */
          var applyDawn = function () {
            var dr = document.querySelector('cart-drawer') || dawnEl;
            if (!dr) return;
            var hasItem = !!(dr.querySelector && dr.querySelector('[id*="CartDrawer-Item"], .cart-item'));
            if (!hasItem && data && data.sections) {
              var toRender;
              try { toRender = dawnEl.getSectionsToRender(); } catch (e) { toRender = [{ id: 'cart-drawer', selector: '#CartDrawer' }, { id: 'cart-icon-bubble' }]; }
              toRender.forEach(function (s) {
                var target = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
                var html = data.sections[s.id] || (s.section ? data.sections[s.section] : null);
                if (!target || !html) return;
                var doc = new DOMParser().parseFromString(html, 'text/html');
                var src = (s.selector ? doc.querySelector(s.selector) : null) || doc.getElementById(s.id) || doc.querySelector('.shopify-section');
                if (src) target.innerHTML = src.innerHTML;
              });
            }
            /* 服务端印在根上的 is-empty 没人摘会把已装货的抽屉藏白 */
            if (dr.classList) dr.classList.remove('is-empty');
            var inner = dr.querySelector ? dr.querySelector('.drawer__inner') : null;
            if (inner && inner.classList) inner.classList.remove('is-empty');
          };
          var boot = function () {
            try { dawnEl.renderContents(data); } catch (e) {}
            applyDawn();
            var dr0 = document.querySelector('cart-drawer') || dawnEl;
            try { if (typeof dr0.open === 'function') { dr0.open(); } else { dr0.classList.add('animate', 'active'); } } catch (e) { dr0.classList.add('animate', 'active'); }
            document.body.classList.add('overflow-hidden');
            /* 哨兵：主题迟到初始化不定何时用空车初始 HTML 盖货——盯 8 秒，被盖即装回（applyDawn 幂等不成环） */
            try {
              var guard = new MutationObserver(function () {
                var dr = document.querySelector('cart-drawer');
                if (dr && !dr.querySelector('[id*="CartDrawer-Item"], .cart-item')) applyDawn();
              });
              guard.observe(document.querySelector('cart-drawer') || document.body, { childList: true, subtree: true });
              setTimeout(function () { guard.disconnect(); }, 8000);
            } catch (e) {}
          };
          if (data && data.sections) { boot(); }
          else {
            /* 点击时元素未升级导致没随单要 sections——自取一份再装 */
            var ids;
            try { ids = dawnEl.getSectionsToRender().map(function (s) { return s.id; }); } catch (e) { ids = ['cart-drawer', 'cart-icon-bubble']; }
            fetch(window.location.pathname + '?sections=' + encodeURIComponent(ids.join(','))).then(function (r) { return r.json(); }).then(function (sec) { data = data || {}; data.sections = sec; boot(); }).catch(function () {});
          }
          opened = true;
        } catch (e) {}
      }
      if (!opened) {
        /* Concept 系：cart:refresh 带 detail.open=true 才会 show() 抽屉（cart.js 实测） */
        try { document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } })); } catch (e) {}
      }
      setTimeout(function () {
        btn.textContent = original;
        btn.disabled = false;
      }, 1200);
    }).catch(function () {
      btn.textContent = 'Error';
      setTimeout(function () {
        btn.textContent = original;
        btn.disabled = false;
      }, 1500);
    });
  }

  function renderInto(host) {
    if (host.getAttribute('data-booted') === '1') return;
    host.setAttribute('data-booted', '1');
    host.setAttribute('data-blog-card', '');

    var handle = host.getAttribute('data-handle') || host.getAttribute('handle');
    var cartLabel = host.getAttribute('data-cart') || host.getAttribute('cart') || 'Add to cart';
    var moreLabel = host.getAttribute('data-more') || host.getAttribute('more') || 'Learn More';
    /* Buy now only when explicitly set — heybike default is Add to cart + Learn More */
    var buyAttr = host.getAttribute('data-buy') || host.getAttribute('buy');
    var buyLabel = buyAttr && buyAttr.trim() ? buyAttr.trim() : '';

    if (!handle) {
      host.innerHTML = '<p class="article-blog-card__error">Missing product handle</p>';
      return;
    }

    host.innerHTML = '<div class="article-blog-card" aria-busy="true">Loading...</div>';

    fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('Product not found');
        return res.json();
      })
      .then(function (product) {
        var variant = null;
        var variants = product.variants || [];
        var i;
        for (i = 0; i < variants.length; i++) {
          if (variants[i].available) {
            variant = variants[i];
            break;
          }
        }
        if (!variant && variants.length) variant = variants[0];

        var image = product.featured_image || (product.images && product.images[0]) || '';
        if (image && typeof image === 'object') {
          image = image.src || image.url || '';
        }
        if (image && image.indexOf('//') === 0) {
          image = 'https:' + image;
        }
        // P2-2: no in-card price — use product type/vendor as subtitle
        var subtitle = product.type || product.vendor || '';

        var disabled = (variant && variant.available === false) ? ' disabled' : '';
        var productUrl = '/products/' + encodeURIComponent(handle);
        var actions = [
          '      <button type="button" class="article-blog-card__btn article-blog-card__btn--primary" data-add' + disabled + '>' + escapeHtml(cartLabel) + '</button>'
        ];
        if (buyLabel) {
          actions.push(
            '      <a class="article-blog-card__btn article-blog-card__btn--buy" href="' + productUrl + '">' + escapeHtml(buyLabel) + '</a>'
          );
        }
        actions.push(
          '      <a class="article-blog-card__btn" href="' + productUrl + '">' + escapeHtml(moreLabel) + '</a>'
        );

        host.innerHTML = [
          '<div class="article-blog-card">',
          '  <div class="article-blog-card__media">',
          image ? '<img src="' + image + '" alt="' + escapeHtml(product.title) + '" loading="lazy" width="448" height="448">' : '',
          '  </div>',
          '  <div class="article-blog-card__body">',
          /* Use p (not h3) to avoid theme `.rte h3` serif + huge margins */
          '    <p class="article-blog-card__title">' + escapeHtml(product.title) + '</p>',
          subtitle ? '    <p class="article-blog-card__subtitle">' + escapeHtml(subtitle) + '</p>' : '',
          '    <div class="article-blog-card__actions">',
          actions.join(''),
          '    </div>',
          '  </div>',
          '</div>'
        ].join('');

        var btn = host.querySelector('[data-add]');
        if (btn && variant) {
          btn.addEventListener('click', function () {
            addToCart(variant.id, btn);
          });
        }
      })
      .catch(function () {
        host.innerHTML = '<p class="article-blog-card__error">Unable to load product: ' + escapeHtml(handle) + '</p>';
      });
  }

  function mountPlaceholders(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll('[data-blog-product-card], blog-product-card');
    var i;
    for (i = 0; i < nodes.length; i++) {
      renderInto(nodes[i]);
    }
  }

  function boot() {
    mountPlaceholders(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    mountPlaceholders(event.target);
  });
})();
